const comments = [
  {
    id: 1,
    name: '影迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20person%20portrait%20with%20warm%20smile%2C%20clean%20minimal%20background%2C%20soft%20natural%20lighting%2C%20casual%20style%2C%20friendly%20expression&width=80&height=80&seq=comment-avatar-1&orientation=squarish',
    time: '2小时前',
    content: '一直在找稳定不卡的在线观看平台，密桃视频真的太惊喜了！红桃视频和樱桃视频的资源都能在这里找到，画质清晰播放流畅，已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    id: 2,
    name: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20Asian%20woman%20portrait%20with%20gentle%20smile%2C%20clean%20warm%20background%2C%20soft%20studio%20lighting%2C%20modern%20casual%20look&width=80&height=80&seq=comment-avatar-2&orientation=squarish',
    time: '5小时前',
    content: '茄子视频和糖心视频的最新剧集这里都有，再也不用切换好几个网站了。更新速度超快，基本上剧集播出当天就能看到高清版，体验一级棒！',
    rating: 5,
  },
  {
    id: 3,
    name: '电影爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20with%20confident%20look%2C%20warm%20neutral%20background%2C%20professional%20soft%20lighting%2C%20clean%20simple%20style&width=80&height=80&seq=comment-avatar-3&orientation=squarish',
    time: '1天前',
    content: '高清全集不缓冲这个真没吹牛，家里网速一般但看1080P完全不卡。电影资源丰富，老片新片都有，分类也很清晰，找片特别方便。',
    rating: 4,
  },
  {
    id: 4,
    name: '深夜剧迷',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20student%20portrait%20with%20bright%20eyes%2C%20warm%20minimal%20background%2C%20soft%20natural%20lighting%2C%20youthful%20casual%20style&width=80&height=80&seq=comment-avatar-4&orientation=squarish',
    time: '2天前',
    content: '每天睡前都要刷几集才安心，密桃视频片库太全了。从热门到小众都有覆盖，而且界面清爽没有乱七八糟的广告，纯粹享受观影乐趣。',
    rating: 5,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-chat-smile-2-line"></i>
            <span>真实反馈</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            看看大家对密桃视频的真实评价，你的观影体验就是我们最关心的事
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <h4 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </h4>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <div className="flex gap-0.5 mt-1.5">
                    {Array.from({ length: comment.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                    {Array.from({ length: 5 - comment.rating }).map((_, i) => (
                      <i key={`e${i}`} className="ri-star-line text-foreground-300 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mt-3">
                    {comment.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}